<template>
    <div
        :class="classFadeIn"
        class="modal fade"
        role="dialog"
        tabindex="-1"
        @click="close"
    >
        <div
            :class="[modal.size ? 'modal-' + modal.size : 'modal-lg']"
            class="modal-dialog modal-dialog-scrollable"
            role="document"
            @click.stop
        >
            <div class="modal-content">
                <form
                    :action="modal.action"
                    :method="modal.method"
                    role="form"
                    @submit.prevent="processModal"
                >
                    <div class="modal-header">
                        <button
                            :disabled="inProcess"
                            aria-label="Close"
                            class="close"
                            type="button"
                            @click="close"
                        >
                            <span aria-hidden="true">
                                <i class="fa fa-times"></i>
                            </span>
                        </button>
                        <h4 class="modal-title">
                            {{ modal.headerText }}
                        </h4>
                    </div>
                    <div class="modal-body">
                        <div
                            v-if="showAlert"
                            class="alert-area"
                        >
                            <div
                                v-if="errors.length > 0"
                                class="alert alert-danger alert-dismissible"
                            >
                                <button
                                    type="button"
                                    class="close"
                                    @click="closeAlert"
                                >
                                    ×
                                </button>
                                <h4><i class="icon fa fa-warning"></i>There are some errors:</h4>
                                <ul>
                                    <li
                                        v-for="(error, idx) in errors"
                                        :key="idx"
                                    >
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <h4 v-if="modal.bodyHeaderText">
                            {{ modal.bodyHeaderText }}
                        </h4>
                        <div v-if="formData">
                            <div
                                v-for="item in formData"
                                :key="item.name"
                                class="row"
                            >
                                <input
                                    v-if="item.type === 'hidden'"
                                    v-model="item.value"
                                    type="hidden"
                                />
                                <div
                                    v-else-if="item.type === 'text'"
                                    class="form-group col-xs-12"
                                >
                                    <label :for="item.key">
                                        {{ item.title }}
                                    </label>
                                    <input
                                        :id="item.key"
                                        v-model="item.value"
                                        type="text"
                                        :placeholder="item.title"
                                        class="form-control"
                                    />
                                </div>
                                <div v-else-if="item.type === 'select'">
                                    <select-component
                                        :searchable="false"
                                        :disabled="inProcess"
                                        :items="item.options"
                                        :selected="item.value"
                                        class-main-block="form-group col-xs-12"
                                        :title="item.title"
                                        @change="changeSelect($event, item)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            :disabled="inProcess"
                            class="btn btn-sm btn-default"
                            type="button"
                            @click="close"
                        >
                            {{ buttonDenyText }}
                        </button>
                        <button
                            :disabled="inProcess"
                            :class="buttonApproveClassColor"
                            class="btn btn-sm"
                            type="submit"
                        >
                            {{ buttonApproveText }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '../../event-bus';
export default {
    props: {
        modal: {
            type: Object,
            default: function () {
                return {
                    entityId: 0,
                    method: '',
                    size: '',
                    headerText: '',
                    bodyHeaderText: '',
                    emitUpdateMethod: '',
                    formData: [],
                    buttonDenyText: '',
                    buttonApproveText: '',
                    buttonApproveClassColor: '',
                };
            },
        },
    },
    data() {
        return {
            timeFadeIn: 150,
            inProcess: false,
            showAlert: false,
            classFadeIn: '',
            errors: [],
            formData: this.modal.formData,
            emitUpdateMethod: this.modal.emitUpdateMethod || 'updateModalData',
            buttonDenyText: this.modal.buttonDenyText || 'Close',
            buttonApproveText: this.modal.buttonApproveText || 'Confirm',
            buttonApproveClassColor: this.modal.buttonApproveClassColor || 'btn-primary',
        };
    },
    mounted() {
        this.setFadeInClass(true);
    },
    methods: {
        changeSelect(value, item) {
            item.value = value;
        },
        prepareFormData() {
            if (!this.formData) {
                return null;
            }
            let preparedFormData = {};
            this.formData.forEach(function (item) {
                preparedFormData[item.key] = item.value;
            });

            return preparedFormData;
        },
        processModal() {
            let self = this;
            self.inProcess = true;
            self.closeAlert();
            axios[this.modal.method](this.modal.route, this.prepareFormData())
                .then(function (resp) {
                    self.emitUpdateMethod && EventBus.$emit(self.emitUpdateMethod, resp.data.data);
                })
                .catch((errors) => {
                    self.showErrors(errors);
                })
                .finally(() => {
                    self.inProcess = false;
                });
        },
        close() {
            this.setFadeInClass(false);
        },
        closeAlert() {
            this.showAlert = false;
            this.errors = [];
        },
        showErrors(errors) {
            let self = this;
            self.showAlert = true;
            if (errors.response.status === 404) {
                self.errors.push('This item does not exist');
            } else if (errors.response.status === 422) {
                for (let key in errors.response.data.errors) {
                    errors.response.data.errors[key].forEach((error) => {
                        self.errors.push(error);
                    });
                }
            } else if (errors.response.status === 419) {
                this.$router.go();
            } else {
                console.error('Server side error.', errors);
            }
        },
        setFadeInClass(status) {
            let self = this;
            !status && (self.classFadeIn = '');
            setTimeout(() => {
                !status && self.$emit('close');
                status && (self.classFadeIn = 'in');
            }, self.timeFadeIn);
        },
    },
};
</script>
<style scoped>
.modal {
    display: block;
}
.modal-body {
    overflow: visible;
}
.modal-footer .btn {
    margin-bottom: 0;
}
</style>
